import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(protected)/[clientId]/page.tsx");
